import type { FormTableExpandedRenderProps } from '@connected/form-fields/components/form-table';
import type { ReactNode } from 'react';

import { NumberField } from '@connected/form-fields/components/form-table';

import type {
    DeviceFormValues,
    DevicePatcher,
} from '../../distribution-board-device/types/hook-types';

type ExpandedImpedanceContentProps = FormTableExpandedRenderProps<DeviceFormValues> & {
    createPatcher: (deviceId: string) => DevicePatcher;
};

const IMPEDANCE_FIELDS = [
    { key: 'ziResistance', header: 'Zi (Ω)', width: '100px' },
    { key: 'ziCurrent', header: 'Ik (Zi)', width: '100px' },
    { key: 'ziMinimalCurrent', header: 'Acceptatiecriteria Zi', width: '175px' },
    { key: 'zsResistance', header: 'Zs (Ω)', width: '100px' },
    { key: 'zsCurrent', header: 'Ik (Zs)', width: '100px' },
    { key: 'zsMinimalCurrent', header: 'Acceptatiecriteria Zs', width: '175px' },
] as const;

export function ExpandedImpedanceContent({
    form,
    row,
    fieldNamePrefix,
    createPatcher,
}: ExpandedImpedanceContentProps): ReactNode {
    const patcher = createPatcher(row.id);

    return (
        <div className="px-4 py-3">
            <table className="w-auto border-collapse">
                <thead>
                    <tr>
                        {IMPEDANCE_FIELDS.map(field => (
                            <th
                                key={field.key}
                                className="px-2 py-1 text-left text-xs font-medium text-muted-foreground"
                                style={{ minWidth: field.width }}
                            >
                                {field.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {IMPEDANCE_FIELDS.map(field => (
                            <td key={field.key} className="px-2 py-1" style={{ minWidth: field.width }}>
                                <form.Field
                                    name={`${fieldNamePrefix}.${field.key}` as any}
                                    validators={{
                                        onChangeAsync: patcher.patchField(field.key),
                                        onChangeAsyncDebounceMs: patcher.patchField.debounceTime,
                                    }}
                                >
                                    {(formField: any) => (
                                        <NumberField field={formField} />
                                    )}
                                </form.Field>
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
